/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_DeletedInputs */

const vi_media_deleted = /** @type {(inputs: Media_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xoá file khỏi thư viện.`)
};

/**

* @param {Media_DeletedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_deleted = /** @type {((inputs?: Media_DeletedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_DeletedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_deleted(inputs)
});